import { useState } from "react";
import concreteImage from "@/assets/landing/p1.jpg";
import yardImage from "@/assets/landing/p2.jpg";
import truckImage from "@/assets/landing/p3.jpg";
import { CloudIcon } from "@/components/icon";

interface Reaction {
	id: string;
	label: string;
	count: number;
	pressed: boolean;
}

const INITIAL_REACTIONS: Reaction[] = [
	{ id: "boa", label: "👍 Boa!", count: 12, pressed: true },
	{ id: "legal", label: "😎 Legal!", count: 4, pressed: false },
	{ id: "uau", label: "😮 Uau!", count: 11, pressed: false },
];

function Reactions() {
	const [reactions, setReactions] = useState(INITIAL_REACTIONS);

	function toggle(id: string) {
		setReactions((current) =>
			current.map((reaction) =>
				reaction.id === id
					? {
							...reaction,
							pressed: !reaction.pressed,
							count: reaction.count + (reaction.pressed ? -1 : 1),
						}
					: reaction,
			),
		);
	}

	return (
		// biome-ignore lint/a11y/useSemanticElements: a toolbar of toggle buttons, not a form fieldset
		<div data-slot="reactions" role="group" aria-label="Reações">
			{reactions.map((reaction) => (
				<button
					key={reaction.id}
					type="button"
					data-slot="reaction"
					aria-pressed={reaction.pressed}
					onClick={() => toggle(reaction.id)}
				>
					{reaction.label} <span>{reaction.count}</span>
				</button>
			))}
		</div>
	);
}

export function FeedPost() {
	return (
		<article data-slot="post" aria-label="Exemplo de relato no feed da obra">
			<div data-slot="post-head">
				<div data-slot="avatar" aria-hidden="true">
					MA
				</div>
				<div data-slot="post-who">
					<b data-slot="post-author">Eng. Marina Alencar</b>
					<small data-slot="post-meta">
						<span data-slot="mono">07:40</span> · <CloudIcon /> Parcialmente
						nublado · <span data-slot="mono">24°C</span>
					</small>
				</div>
			</div>
			<div data-slot="post-body">
				<span data-slot="chip">Estrutura / Lajes</span>
				<h3 data-slot="post-title">Concretagem da laje do 7º pavimento</h3>
				<p data-slot="post-text">
					Caminhão-betoneira da usina Serra Azul chegou às 07h40. Lançamento por
					bomba lança, slump de 10 ± 2 cm conferido em obra.
				</p>
			</div>
			<div data-slot="post-media">
				<img
					src={truckImage}
					alt="Caminhão-betoneira e bomba lança no canteiro"
					width={1100}
					height={825}
				/>
				<img
					src={concreteImage}
					alt="Equipe lançando concreto sobre a armadura da laje"
					width={1100}
					height={825}
				/>
				<img
					src={yardImage}
					alt="Pátio de materiais do canteiro"
					width={1100}
					height={825}
				/>
			</div>
			<div data-slot="post-foot">
				<Reactions />
				<small data-slot="post-place">
					Residencial Alto da Serra · Torre B
				</small>
			</div>
		</article>
	);
}
